/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ImageSerie/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import ButtonIconLabel from 'DesignSystem/ButtonIconLabel/index'
import FolderIcon from 'DesignSystem/Svgs/FolderIcon/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function ImageSerie({
  children,
  viewPath = "/DesignSystem/PreviewDocument/Content/Content/HtmlFile/Content/Content/Content/Actions/Upload/Content/Documents/Content/SystemFiles/FilesTree/ImageSeries/Content/ImageSeriesList/ImageSerie"
  
}) {
let imageSerieNameValueData = fromData.useDataValue({ viewPath,
context: 'image_serie',
path: 'name',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<ButtonIconLabel
  viewPath={`${viewPath}/ButtonIconLabel`}
 marginTop={4}
 data="image_serie.name"
 text={imageSerieNameValueData}
 onClick={onClick}
>
{childProps => (
<FolderIcon
{...childProps}
  viewPath={`${viewPath}/FolderIcon`}
 width={16}
 height={16}
 stroke="rgba(0,0,0,0.7)"
/>
)}
</ButtonIconLabel>
{children}
</React.Fragment>)
}